import ContentsTypes from "@shared/enums/contentsTypes";
import customTypes from "@project/enums/contentsCustomTypes.enum";
const getDynamicAdminContentsTypes = ({ type }) => {
    switch (type) {
        case ContentsTypes.ROW:
        case ContentsTypes.SECTION:
        case ContentsTypes.CONTAINER:
        case ContentsTypes.EXPANSION_PANEL_DETAILS:
        case ContentsTypes.DYNAMIC:
            return [
                customTypes.ARTICLE_SECTION,
                customTypes.GEOGRAPHIC_MAP,
                customTypes.PRESENTATION_BLOCK,
                customTypes.PRESENTATION_CARD,
                customTypes.BLOCK_WITH_TITLE,
                customTypes.TEXT_BLOCK_WITH_TITLE,
                customTypes.TABS_COMPONENT,
                customTypes.DESCRIPTION_BLOCK,
                customTypes.DESCRIPTION_CARD_WITH_LOGO,
                customTypes.BLOCK_TITLE,
                customTypes.CONTACT_FORM,
                customTypes.MAILTO,
                customTypes.HORIZONTAL_INFOS,
                customTypes.PRODUCT_BLOCK,
                customTypes.CONTACT_BLOCK,
                customTypes.CARDS_GRID,
                customTypes.AUTO_SCROLLING_INFOS,
                customTypes.SKILLS_TAB_PANEL,
                customTypes.DESCRIPTION_SECTION,
                customTypes.DOCAPOSTE_SECTION,
                customTypes.ARTICLE_CARD_LIST,
            ];
        case ContentsTypes.GRID:
            return [
                customTypes.PRESENTATION_BOX,
                customTypes.TROMBINOSCOPE,
                customTypes.PRESENTATION_BLOCK,
                customTypes.PRESENTATION_CARD,
                customTypes.DESCRIPTION_CARD_WITH_LOGO,
                customTypes.BLOCK_WITH_TITLE,
                customTypes.TEXT_BLOCK_WITH_TITLE,
                customTypes.DESCRIPTION_BLOCK,
                customTypes.BLOCK_TITLE,
                customTypes.CONTACT_FORM,
                customTypes.HORIZONTAL_INFOS,
                customTypes.PRODUCT_BLOCK,
                customTypes.CONTACT_BLOCK,
                customTypes.CARDS_GRID,
                customTypes.AUTO_SCROLLING_INFOS,
                customTypes.SKILLS_TAB_PANEL,
                customTypes.DESCRIPTION_SECTION,
                customTypes.DOCAPOSTE_SECTION,
                customTypes.ARTICLE_CARD_LIST,
                customTypes.ARTICLE_CARD_LIST_ITEM,
            ];
        default:
            return [];
    }
};
export default getDynamicAdminContentsTypes;
